export default defineNuxtPlugin(async () => {

    const {data} = await useFetch('/api/pixels', {
        headers: {
            'Authorization': process.env.GOOGLE_TAG_KEY,
        }
    });

    if (process.client) {
        if (!data?.value?.data) {
          return;
        }
        const pixels = data.value.data;

        const script = document.createElement('script')

        pixels.forEach(pixel => {
            script.src = 'https://www.googletagmanager.com/gtag/js?id=' + pixel.google_id
            script.async = true
            document.head.appendChild(script)

            window.dataLayer = window.dataLayer || []
            window.gtag = function () {
                window.dataLayer.push(arguments)
            }
            window.gtag('js', new Date())

            pixels.forEach(pixel => {
                window.gtag('config', pixel.google_id)
            })
        });
    }
})